import common_axios from "./commonAxios";

let baseURL = common_axios.defaults.baseURL;

export const getHistory = (
  recordsPerPage,
  page,
  indexType,
  indexId,
  sortBy = "DiscountDESC"
) => {
  // var dataPass = common_axios.get(baseURL + `product/physical_product_catalog?recordsPerPage=${recordsPerPage}&page=${page}`);
  var dataPass = common_axios.get(
    baseURL +
      `store_product/catalog?recordsPerPage=${recordsPerPage}&page=${page}&indexType=${indexType}&indexId=${indexId}&sortby=${sortBy}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const getCart = (userId) => {
  var dataPass = common_axios.get(
    baseURL + `store_product/cart_display?userId=${userId}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const addContactForm = (userData) => {
  var dataPass = common_axios.post(
    "https://fakestoreapi.com/products",
    userData
  );
  return dataPass;
};

export const productDetailsCall = (productId, couponId) => {
  var dataPass = common_axios.get(
    baseURL +
      `store_product/product_details?productId=${productId}&couponId=${couponId}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const login = (
  contactInfo,
  otp,
  isValid = 1,
  isEmail = false,
  country = null
) => {
  // console.log(user)
  // Use isEmail parameter to determine if it's email or mobile
  // This is needed because registerdEmail might be encoded and won't contain '@'
  const paramName = isEmail ? "email" : "mobileNo";
  let url = `store_user/user_otp_verification?${paramName}=${contactInfo}&otp=${otp}&isValid=${isValid}`;

  // Add country parameter if provided (for non-Indian citizens)
  if (country) {
    url += `&country=${encodeURIComponent(country)}`;
  }

  var dataPass = common_axios.post(url);
  // console.log(dataPass);
  return dataPass;
};
export const pentaCsvUpload = (file) => {
  var dataPass = common_axios.post(`/store_spicegold/penatregistration`, file);
  return dataPass;
};
export const loginDirect = (mobile, otp, isValid = 1) => {
  // console.log(user)
  var dataPass = common_axios.post(
    `store_user/user_otp_verification_direct?mobileNo=${mobile}&otp=${otp}&isValid=${isValid}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const getBanner = () => {
  var dataPass = common_axios.get("https://dummyjson.com/products/");
  // console.log(dataPass);
  return dataPass;
};

export const getCategory = () => {
  var dataPass = common_axios.get("https://dummyjson.com/products/");
  // console.log(dataPass);
  return dataPass;
};

export const getCategorys = () => {
  var dataPass = common_axios.get(`/store_product/product_category`);
  // console.log(dataPass);
  return dataPass;
};

export const getDiscountedProducts = (discountValue) => {
  var dataPass = common_axios.get(
    `/store_product/catalog_discount?recordsPerPage=5&page=1&indexType=categoryId&indexId=a242V2JBRVRVOWZhMDc5YVdWZnQ3UT09&sortby=DiscountDESC&discount=${discountValue}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const getAddress = (id) => {
  var dataPass = common_axios.get(
    `/store_user/address_fetch_string?userId=${id}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const getAddressId = (id) => {
  var dataPass = common_axios.get(
    `/store_user/address_fetch_single_string?addressId=${id}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const addAddressId = (data) => {
  var dataPass = common_axios.post(`/store_user/address_update`, data);
  // console.log(dataPass);
  return dataPass;
};

export const removeAddressId = (id) => {
  var dataPass = common_axios.get(`/store_user/address_remove?addressId=${id}`);
  // console.log(dataPass);
  return dataPass;
};
export const getDeals = () => {
  var dataPass = common_axios.get("/store_store/home");
  // console.log(dataPass);
  return dataPass;
};

export const emailVerification = (email) => {
  var dataPass = common_axios.get(
    `/store_user/email_verification?email=${email}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const emailOTPVerification = (otp, email, isValid = 1, country = "") => {
  // Use user_otp_verification_raw_email endpoint for profile page email OTP verification
  let url = `store_user/user_otp_verification_raw_email?email=${email}&otp=${otp}&isValid=${isValid}`;

  // Add country parameter if provided (for non-Indian citizens)
  if (country) {
    url += `&country=${encodeURIComponent(country)}`;
  }

  var dataPass = common_axios.post(url);
  // console.log(dataPass);
  return dataPass;
};
export const addedToCart = (id, productQty, type, skuId, no, couponId) => {
  var dataPass = common_axios.post(
    `/store_product/addto_cart?productId=${id}&quantity=${productQty}&skuId=${skuId}&number=${no}&couponid=${couponId}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const deleteCartId = (id) => {
  var dataPass = common_axios.post(
    `/store_product/remove_item_from_cart?itemId=${id}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const getOtp = (contactInfo) => {
  // console.log()
  // Check if the input is an email (contains @) or a contact number
  const isEmail = contactInfo && contactInfo.includes("@");
  const payload = isEmail ? { email: contactInfo } : { mobileNo: contactInfo };

  var dataPass = common_axios.post(`store_user/user_login`, payload);
  return dataPass;
};

export const getOtpDirect = (mobileNo) => {
  // console.log()
  var dataPass = common_axios.post(`store_user/user_login_direct`, {
    mobileNo: mobileNo,
  });
  return dataPass;
};

export const getSpiceBalance = () => {
  // console.log()
  var dataPass = common_axios.get(`store_spicegold/spicegold_balance`);
  return dataPass;
};

export const coupon_details = () => {
  // console.log()
  var dataPass = common_axios.post(`store_user/coupon_details`);
  return dataPass;
};

export const getUserDetails = (id) => {
  var dataPass = common_axios.get(`store_user/user_information?userId=${id}`);
  return dataPass;
};

export const updateUser = (user) => {
  // console.log(user.firstName,user.lastName,user.userName)
  var dataPass = common_axios.post(`store_user/user_registration_update`, user);
  return dataPass;
};

export const increaseDecrease = (itemId, x) => {
  var dataPass = common_axios.post(
    `store_product/cart_quantity_increase_decrease?itemId=${itemId}&quantity=${x}`
  );
  return dataPass;
};

export const getOrderDetails = (authId, couponId) => {
  var dataPass = common_axios.get(
    `store_order/order_details?couponId=${couponId}`
  );
  return dataPass;
};
export const getOrderHistory = () => {
  var dataPass = common_axios.get(`store_order/order_history`);
  return dataPass;
};

export const checkUsernameService = (userName, userId) => {
  var dataPass = common_axios.get(
    `store_user/check_username?userId=${userId}&userName=${userName}`
  );
  return dataPass;
};

export const checkUsernameServiceWithoutLogin = (userName) => {
  var dataPass = common_axios.get(
    `store_user/check_username_linked_id?userName=${userName}`
  );
  return dataPass;
};
// check_username_linked_id?userName=hd

export const getOrdersuccessful = (orderId) => {
  var dataPass = common_axios.get(
    `store_order/order_successful?order_id=${orderId}`
  );
  return dataPass;
};
export const getpaymentDetails = (orderId) => {
  var dataPass = common_axios.get(
    `store_order/order_status?order_id=${orderId}`
  );
  return dataPass;
};
export const getOrderFailed = (response) => {
  var dataPass = common_axios.get(
    `store_order/order_failure?order_id=${response}`
  );
  return dataPass;
};
export const getCount = () => {
  var dataPass = common_axios.get(`store_product/cart_count`);
  return dataPass;
};

export const helpapi = (data) => {
  var dataPass = common_axios.post(`store_store/support`, data);
  return dataPass;
};
export const helpsupport = () => {
  var dataPass = common_axios.get(`store_store/supportcheck`);
  return dataPass;
};

// export const add_orderId = (addressId) => {
//     var dataPass = common_axios.get(`order/add_order?addressId=${addressId}`)
//     return dataPass;
// };
// changed
export const add_orderId = (addressId, method) => {
  var dataPass = common_axios.get(
    `store_order/add_order?addressId=${addressId}&method=${method}`
  );
  return dataPass;
};
export const getLedger = () => {
  var dataPass = common_axios.get(`store_spicegold/earned_burned`);
  return dataPass;
};

export const terms = (message) => {
  var dataPass = common_axios.post(`store_store/tandc?tandc=${message}`);
  return dataPass;
};

export const searchs = (keyword = "") => {
  var dataPass = common_axios.get(`store_store/search?keyword=${keyword}`);
  // console.log(dataPass);
  return dataPass;
};
export const search_result = (keyword, productId, result) => {
  // console.log(keyword,productId)
  var dataPass = common_axios.post("/store_store/search_result", {
    keyword: keyword,
    productId: productId,
    result: result,
  });
  // console.log(dataPass);
  return dataPass;
};

export const searchDelete = (productId) => {
  var dataPass = common_axios.get(
    `/store_store/search_delete?productId=${productId}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const direct = (skuid) => {
  var dataPass = common_axios.get(`/store_direct/gv?skuid=${skuid}`);
  // console.log(dataPass);
  return dataPass;
};

export const getWalkthrowStatus = () => {
  var dataPass = common_axios.get(`store_user/walkthrough`);
  // console.log(dataPass);
  return dataPass;
};

export const changeWalkthrowStatus = (result) => {
  console.log(result, ",jhdg");
  var dataPass = common_axios.get(
    `store_user/walkthrough_result?result=${result}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const product_hfsg = (couponId, page, limit, sortby, isValid) => {
  var dataPass = common_axios.get(
    `store_product/product_hunt_for_spice_gold?couponId=${couponId}&page=${page}&limit=${limit}&sortby=${sortby}&isValid=${isValid}`
  );
  // console.log(dataPass);
  return dataPass;
};
export const total_coupon_by_game = (couponId) => {
  const dataPass = common_axios.get(
    `store_product/total_coupon_by_game?couponId=${couponId}`
  );
  // console.log(dataPass);
  return dataPass;
};

export const leaderboard = () => {
  const dataPass = common_axios.get(`store_user/leaderboard`);
  // console.log(dataPass);
  return dataPass;
};

export const getMessagesForTickets = async (ticketId) => {
  const dataPass = common_axios.get(
    `/store_store/support_get_message?ticketId=${ticketId}`
  );
  // console.log(dataPass);
  return dataPass;
};
export const createMessagesForTickets = async (ticketId, data) => {
  const dataPass = common_axios.post(
    `store_user/create_message_ticket?ticketId=${ticketId}`,
    data
  );
  // console.log(dataPass);
  return dataPass;
};

export const getEventDetail = async () => {
  const dataPass = common_axios.get(`/store_user/event_details`);
  // console.log(dataPass);
  return dataPass;
};

export const getStarTransactions = async () => {
  const dataPass = common_axios.get(`/store_spicegold/earned_burned_star`);
  // console.log(dataPass);
  return dataPass;
};

export const claimReward = async (addressId) => {
  const dataPass = common_axios.get(
    `/store_order/claim?addressId=${addressId}`
  );
  return dataPass;
};

export const getTotalDiscounts = async () => {
  const dataPass = common_axios.get(`/store_order/product_stats`);
  return dataPass;
};

export const dealProductDetail = async (productId) => {
  const dataPass = common_axios.get(
    `/store_product/product_details_discount?productId=${productId}&couponId=null
`
  );
  return dataPass;
};

export const getPasses = async () => {
  const dataPass = common_axios.get(
    `/store_product/catalog_coupon?recordsPerPage=5&page=1&indexType=categoryId&indexId=a242V2JBRVRVOWZhMDc5YVdWZnQ3UT09&sortby=DiscountDESC&discount=100`
  );
  return dataPass;
};

export const claimCoupon = async (productId, addressId, couponId) => {
  const dataPass = common_axios.get(
    `/store_order/claim_coupon?productId=${productId}&addressId=${addressId}&couponId=${couponId}`
  );
  return dataPass;
};

export const applyReferral = async (referralCode) => {
  const dataPass = common_axios.get(
    `/store_user/apply_referral?code=${referralCode}`
  );
  return dataPass;
};

export const getReferredFriends = async () => {
  const dataPass = common_axios.get(`/store_user/referral_list`);
  return dataPass;
};

export const incrementReferralShareCount = async (referralCode) => {
  const dataPass = common_axios.get(
    `/store_user/increment_referral_share_count?code=${referralCode}`
  );
  return dataPass;
};

export const getGamerClubProducts = async () => {
  const dataPass = common_axios.get(`/store_product/test`);
  return dataPass;
};

// Promo-related APIs
export const getPromoEligibility = async (promoId) => {
  const dataPass = common_axios.get(
    baseURL + `store_promo/eligible?promoId=${promoId}`
  );
  return dataPass;
};

export const getActivePromos = async () => {
  const dataPass = common_axios.get(baseURL + `store_promo/active`);
  return dataPass;
};

export const grantPromo = async (promoId, addressId = null) => {
  let url = baseURL + `store_promo/grant?promoId=${promoId}`;
  if (addressId) {
    url += `&addressId=${addressId}`;
  }
  const dataPass = common_axios.get(url);
  return dataPass;
};

export const checkEventWinnerStatus = async () => {
  const dataPass = common_axios.get(`/store_user/check_event_winner_status`);
  return dataPass;
};

export const submitWinnerDetails = async (formData) => {
  const dataPass = common_axios.post(`/store_user/winner_details`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return dataPass;
};
